import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import * as msg from '../form/Msg';
import PhoneInput from '../form/PhoneInput';

const Callback = ({ destroy, title, topic, prod, isOpen=true }) => {
  const [ok, setOK] = useState(false);
  const [err, setErr] = useState(false);
  const [nowSubmit, setNowSubmit] = useState(false);

  // handle back scrolling when show modal, need!!!!!
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const formik = useFormik({
    initialValues: {
      name: '',
      phone: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required(msg.ERR_NAME_REQUIRED),
      phone: Yup.string().phone().required(msg.ERR_PHONE_REQUIRED),
    }),
    onSubmit: (values, { setSubmitting, resetForm }) => {
      if (nowSubmit) {
        return;
      }
      setNowSubmit(true);
      setSubmitting(true);

      const params = Array.from(Object.entries(values)).reduce((acc, p) => {
        const [key, val] = p;
        acc.append(`data[${key}]`, val);
        return acc;
      }, new URLSearchParams());
      if (topic !== null) {
        params.append('data[topic]', topic);
      }
      if (prod !== null) {
        params.append('data[prod]', prod);
      }
      params.append('data[rId]', 1);

      fetch('/mail/callback', {
        method: 'post',
        body: params,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then((resp) => resp.json())
        .then((data) => {
          if (data.status !== 1) {
            throw new Error('not ok');
          }
        })
        .then(() => {
          setOK(true);
          resetForm();
        })
        .catch(() => setErr(true))
        .then(() => {
          setNowSubmit(false);
          setSubmitting(false);
        });
    },
  });

  const errClass = (fld) => {
    const className =
      formik.touched[fld] && formik.errors[fld]
        ? 'app-callback__fld_error'
        : '';
    return className;
  };

  const ErrMsg = ({ formik, fld }) => {
    return (
      <>
        {formik.touched[fld] && formik.errors[fld] ? (
          <div className="app-callback__error error__message ">{formik.errors[fld]}</div>
        ) : null}
      </>
    );
  };

  return (
    <div className={`modal-content ${isOpen ? 'active' : ''}`}>
      <div className={`back-call__block ${isOpen ? 'active' : ''}`}>
        <div className="drawer-handle" />
        <div className="close" onClick={destroy} />

        {ok && (
          <div className="mod-thenks">
            <h4>Спасибо!</h4>
            <p>
              Мы свяжемся с вами в ближайшее время График работы: пн-вс, 9:00 -
              20:00{' '}
            </p>
            <span className="btn" onClick={destroy}>
              Вернуться к покупкам
            </span>
          </div>
        )}

        {!ok && (
          <>
            <div className="buy-click__cnt">
              <h3>{title}</h3>
              {err && <h4>{msg.ERR_SRV}</h4>}
            </div>

            <form onSubmit={formik.handleSubmit}>
              <div className="modal-inp__fl">
                <div className={`modal-inp modal-inp__act ${errClass('name')}`}>
                  <span className="tit-form">Имя</span>
                  <label>
                    <input
                      type="text"
                      name="name"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                    />
                  </label>
                  <ErrMsg formik={formik} fld="name" />
                </div>
              </div>

              <div className="modal-inp__fl">
                <div
                  className={`modal-inp modal-inp__act ${errClass('phone')}`}
                >
                  <span className="tit-form">Телефон</span>
                  <label>
                    <PhoneInput
                      type="tel"
                      name="phone"
                      className="phone"
                      value={formik.values.phone}
                      onChange={formik.handleChange}
                    />
                  </label>
                  <ErrMsg formik={formik} fld="phone" />
                </div>
              </div>

              {!nowSubmit && (
                <button
                  className="btn"
                  onClick={formik.handleSubmit}
                  type="submit"
                >
                  Отправить
                </button>
              )}
              {nowSubmit && (
                <button className="btn">Обработка данных...</button>
              )}
              <div className='modal__info__footer'>
                <div className='modal__info__content'>
                  <p>
                    Нажимая кнопку “Отправить”, Вы даете свое согласие на обработку
                    <span
                      onClick={() => window.open('/legal-information', '_blank')}>
                      персональных данных
                    </span>
                  </p>
                </div>
              </div>
            </form>
          </>
        )}
      </div>
      <div className="app-callback__backdrop" />
    </div>
  );
};

export default Callback;
